import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let { HEADER_FONT_COLOR } = constants;

let styles = {
  base: {
    height: '70%',
    borderRight: `1px solid ${HEADER_FONT_COLOR}`,
    opacity: 0.2,
    margin: '0 15px',
    '@media (max-width: 475px)': {
      margin: '0 8px'
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/vseparator/VerticalSeparator.styles.js